export default __webpack_public_path__ + "static/media/totalStaked.730324e5.svg";